import { getApi } from 'apis';

 const getMasterEarnings = async () => {
	return await getApi('/data/earnings');
};

 const getMasterDeductions = async () => {
		return await getApi('/data/deductions');
 };


export const dataApi = {
	getMasterDeductions,
	getMasterEarnings,
};
